import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActionLogActions } from './action-log.actions';
import { selectActionLogFilter } from './action-log.selectors';
import { ACTION_LOG_STATE_SERVICE_INJECTION_TOKEN, ActionLogStateService } from '../../../core/services/api/action-log-state-service.interface';

@Injectable()
export class ActionLogEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private actionLogStateService = inject<ActionLogStateService>(
    ACTION_LOG_STATE_SERVICE_INJECTION_TOKEN,
  );

  public updateActionLogFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionLogActions.public.updateActionLogFilter),
      map((_props) => ActionLogActions.private.loadActionLogWithFilters()),
    ),
  );

  public loadActionLogWithFilters$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ActionLogActions.private.loadActionLogWithFilters),
        withLatestFrom(this.store.select(selectActionLogFilter)),
        switchMap(([_action, filter]) =>
          this.actionLogStateService.getActionLog(filter).pipe(
            map((response) =>
              ActionLogActions.private.loadActionLogSuccess({
                actionLogResponseDto: response,
              }),
            ),
            catchError((error) =>
              of(ActionLogActions.private.loadActionLogFailure({ error })),
            ),
          ),
        ),
      ),
    { dispatch: true },
  );
}
